{
  "login.title": "Sign in",
  "login.email.label": "Email address",
  "login.email.placeholder": "you@example.com",
  "login.submit": "Continue",
  "login.submitting": "Sending…",
  "login.passkey": "Use a passkey",
  "login.or": "or",
  "login.turnstile.failed": "Anti-bot check failed. Please try again.",
  "login.email.invalid": "Invalid email address.",
  "login.success": "We sent you a sign-in link.",
  "logout.success": "Signed out.",
  "session.expired": "Your session expired. Please sign in again.",
  "security.title": "Security",
  "security.passkeys.title": "Passkeys",
  "security.passkeys.intro": "Sign in with Face ID, Touch ID or a security key — no more waiting for a link.",
  "security.passkeys.empty": "No passkey yet.",
  "security.passkeys.add": "Add a passkey",
  "security.passkeys.adding": "Adding…",
  "security.passkeys.namePlaceholder": "Name (optional), e.g. MacBook",
  "security.passkeys.unnamed": "Unnamed passkey",
  "security.passkeys.created": "Added {{date}}",
  "security.passkeys.synced": "Synced",
  "security.passkeys.deviceOnly": "This device only",
  "security.passkeys.rename": "Rename",
  "security.passkeys.save": "Save",
  "security.passkeys.cancel": "Cancel",
  "security.passkeys.delete": "Delete",
  "security.passkeys.deleteConfirm": "Delete this passkey? You won't be able to sign in with it anymore.",
  "security.passkeys.added": "Passkey added.",
  "security.passkeys.cancelled": "Cancelled.",
  "security.passkeys.alreadyRegistered": "This device already has a passkey for this account.",
  "security.passkeys.loadError": "Couldn't load your passkeys.",
  "security.passkeys.retry": "Retry",
  "security.passkeys.error": "Something went wrong. Try again.",
  "security.passkeys.sessionNotFresh": "To add a passkey, sign in again first (session older than 24 h).",
  "security.passkeys.signOut": "Sign out",
  "security.passkeys.loading": "Loading your passkeys…",
  "security.unsupported": "This browser doesn't support passkeys.",
  "nudge.passkey.text": "Add a passkey and stop waiting for sign-in links.",
  "nudge.passkey.add": "Add a passkey",
  "nudge.passkey.later": "Later",
  "login.passkey.cancelled": "Passkey sign-in cancelled.",
  "login.passkey.notFound": "No passkey found for this site — use the email link.",
  "login.passkey.failed": "Passkey sign-in failed — use the email link."
}
